import { ILEGGELSE_SERVICE_BASE_URL } from "../config.ts";

export const GET_SKIFTLOGGER_URL = `${ILEGGELSE_SERVICE_BASE_URL}/skift`;
